export enum ScheduleNotificationType {
    warning = 1,
    promotion = 2,
    notice = 3,
    post = 4,
}
